import React, { useState, useRef, useEffect } from "react";
import {
	Modal,
	Form,
	Row,
	Col,
	Overlay,
	Popover,
	Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import Flatpickr from "react-flatpickr";
import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import {
	fetchIndustryData,
	setSelectedIndustry,
} from "../../redux/actions/industryActions";
import { useDispatch, useSelector } from "react-redux";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";

import { customStyles } from "../../selectStyles";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";
import {
	fetchSpecialization,
	selectSpecialization,
} from "../../redux/actions/specializationAction";
import {
	fetchQualification,
	selectQualification,
} from "../../redux/actions/qualificationAction";
import { useParams } from "react-router-dom";
import {
	fetchInstituteData,
	selectGetInstitute,
} from "../../redux/actions/getInstitutesAction";
import { fetchAllOrgsData } from "../../redux/actions/getAllOrgsAction";
import { fetchOrgRegdInsData } from "../../redux/actions/getRegdInsAction";


const EditEducation = ({
	show,
	handleClose,
	userEducation,
	userDataId,
	userDataInfo,
	getUserCv,
}) => {
	const sessionId = localStorage.getItem("sessionId");
	const { CandidateId } = useParams();
	const userType = localStorage.getItem("userType");
	// console.log("user Education1", userEducation);
	const [display, setDisplay] = useState(false);

	const [institution, setInstitution] = useState(null);
	const [city, setCity] = useState(null);
	const [field, setField] = useState("");
	const [degree, setDegree] = useState("");
	const [grade, setGrade] = useState("");
	const [isPresent, setIsPresent] = useState(false);
	const [startYear, setStartYear] = useState("");
	const [endYear, setEndYear] = useState("");
	const [description, setDescription] = useState("");
	const [activities, setActivities] = useState("");
	const [AcademicAchiv, setAcademicAchiv] = useState("");


	const [showTooltip, setShowTooltip] = useState(false);
	const targetRef = useRef(null);
	const [OrganizationName, setOrganizationName] = useState("");

	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");

	const [industryDataName, setIndustryDataName] = useState("");
	const [InsName, setInsName] = useState("");

	const [formChanged, setFormChanged] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleModalClose = () => {
		setTempCity({ value: cityId, label: cityList.find(c => c.value === cityId)?.label || userEducation.cityName });
	};
	// Handle changes and mark form as modified
	const handleFieldChange = (setter, value) => {
		setter(value);
		setFormChanged(true); // Enable Submit button
	};

	console.log("userEducation===>", userEducation);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setDisplay(true);
		setIsSubmitting(true); // Disable the button during submission

		// Applying conditions for institution fields
		let institutionId = 0;
		let orgType = 0;
		let gnrlOrgInsttnId = 0;

		if (industryDataId) {

			institutionId = orgTypeId === 4 ? null : industryDataId;
			orgType = orgTypeId === 4 ? 4 : orgTypeId;
			gnrlOrgInsttnId = orgTypeId === 4 ? industryDataId : null;

		} else if (getOrgInsTId) {
			institutionId = null;
			orgType = 4;
			gnrlOrgInsttnId = getOrgInsTId;
		}
		const body = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: userType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,

			institutionId,
			orgType,
			gnrlOrgInsttnId,

			// startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
			// endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
			qualification: qualificationId,
			specilization: specializationId,
			grade: grade,
			// activities: activities,
			description: description,
			cityId: cityId,
			// cityId: cityId,
			// startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
			isPresent: isPresent,
			// endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
			startYear: startDate ? moment(startDate).format("YYYY") : "",
			startMonth: startDate ? moment(startDate).format("MM") : "",
			endYear: endDate ? moment(endDate).format("YYYY") : "",
			endMonth: endDate ? moment(endDate).format("MM") : "",

			eduId: userEducation.usrDataEductnId,
		};
		console.log("update body", body);
		if (
			(industryDataId === "" && getOrgInsTId === "") ||
			(orgTypeId === "" && newOrgType === "") ||
			degree === "" ||
			field === "" ||
			cityId === null ||
			AcademicAchiv === '' ||
			startDate === ""
		) {
			toast.error("Please fill all the required fields");
			setIsSubmitting(false); // Re-enable the button if validation fails
		} else {
			try {
				const res = await axios.post("/Resume/UpdateEducation", body);

				toast.success(res.data.message);
				handleClose();
				getUserCv();
				setDisplay(false);
				setFormChanged(false); // Disable the button after update
			} catch (error) {
				if (error.response && error.response.status === 404) {
					toast.error(error.response.data.message);
				} else {
					toast.error(error.response?.data?.message);
				}
			} finally {
				setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
			}
		}
	};

	// ...............................City DDL.......................................
	const dispatch = useDispatch();
	const [cityId, setCityId] = useState("");
	const [cityName, setCityName] = useState('')
	const [tempCity, setTempCity] = useState(null);
	console.log("cityId==>", cityId);

	const { cityList, selectedcityId } = useSelector((state) => state.cities);
	console.log("City List===>", cityList)
	useEffect(() => {
		dispatch(fetchCityData());

	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		dispatch(fetchCityData(inputValue));
	};

	const handleCityChange = (option) => {
		setTempCity(option); // UI ke liye value change karo
		// if (option) setCityId(option.value); // Sirf tab update ho jab user select kare
		handleFieldChange(setCityId, option ? option.value : "");
	};

	// const handleCitySelect = (selectedOption) => {
	// 	// console.log("selectedOption", selectedOption);

	// 	if (selectedOption) {
	// 		// dispatch(selectCity(selectedOption.value));
	// 		setCityId(selectedOption.value);
	// 	} else {
	// 		setCityId(null);
	// 		setFormChanged(true); // Enable the Update button
	// 	}
	// };
	const [searchTerm, setSearchTerm] = useState("")
	const [cityNameOption, setCityNameOption] = useState([])
	const [orgCity, setOrgCity] = useState(null);

	const getCityList = async (pageNumber = 1, pageSize = 10) => {
		try {
			const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
				pageNumber,
				pageSize
			})
			console.log("Get City Name List==>", response)
			const cityList = response.data.responseData.citiesDDL.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setCityNameOption(cityList)
		}
		catch (error) {
			//toast.error(error.message || 'Something went wrong while fetching city data',)
		}
	}

	useEffect(() => {
		getCityList();
	}, [searchTerm]);

	const handleCitySelectOrg = (selectedOption) => {
		setOrgCity(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};

	const handleCitySelect1 = (selectedOption) => {
		console.log("selectedOption", selectedOption);

		setCityId(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};
	// ...............................City DDL.......................................
	// ...............................Industry DDL.......................................
	// const [industryId, setIndustryId] = useState(null);
	const { industryList, selectedIndustryId } = useSelector(
		(state) => state.industry
	);
	useEffect(() => {
		dispatch(fetchIndustryData());
	}, [dispatch]);
	const handleIndustrySelect = (val) => {
		dispatch(setSelectedIndustry(val.value));
		setFormChanged(true); // Enable the Update button
	};
	// ...............................Industry DDL.......................................


	const toggleTooltip = () => {
		// console.log("Toggling Tooltip");
		setShowTooltip((prev) => !prev);
	};

	// const handleCitySelect1 = (selectedOption) => {
	//   if (selectedOption) {
	//     setOrgCity(selectedOption.value);
	//   } else {
	//     setOrgCity(null);
	//   }
	// };

	const [newOrgType, setnewOrgType] = useState(null);

	const [fileName, setFileName] = useState("");
	const handleFileChange = (event) => {
		const file = event.target.files[0];
		if (file) {
			setFileName(file.name);
		}
	};
	const [getOrgInsTId, setGenOrgInstId] = useState(null);

	const handleSaveInstitution = async () => {
		// setDisplay(true);

		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdInstitution");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		// console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			// console.log("res", res);
			const newOrg = {
				value: res.data.responseData.id,
				label: OrganizationName,
				tagId: 4,
			};

			dispatch(fetchOrgRegdInsData());
			setIndustryDataId(res.data.responseData.id)
			setInsName("")
			//setGenOrgInstId(res.data.responseData.id);
			//setnewOrgType(res.data.responseData.value);
			toast.success(res.data.message);

			setOrganizationName("");
			setOrgCity(null);
			setFileName("");



			// **Enable the submit button after saving**
			setFormChanged(true);
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};

	// ...............................Specialization DDL.......................................
	const [specializationId, setSpecilizationId] = useState("");
	const { SpecializationList, selectedSpecializationId } = useSelector(
		(state) => state.specialization
	);
	useEffect(() => {
		dispatch(fetchSpecialization());
	}, [dispatch]);

	const handleSpecializationSelect = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectSpecialization(selectedOption.label));
			setSpecilizationId(selectedOption.label);
		} else {
			setSpecilizationId(null);
			setFormChanged(true); // Enable the Update button
		}
	};

	// ...............................Qualification DDL.......................................
	const [qualificationId, setqualificationId] = useState("");

	const { qualficationList, selectedqualficationId } = useSelector(
		(state) => state.qualification
	);
	useEffect(() => {
		dispatch(fetchQualification());
	}, [dispatch]);
	const handleQualificationSelect = (selectedOption) => {
		if (selectedOption) {
			setqualificationId(selectedOption.label);
			// dispatch(selectQualification(selectedOption.label));
		} else {
			setqualificationId(null);
			setFormChanged(true); // Enable the Update button
		}
	};

	// ...............................Industry DDL.......................................
	const [orgTypeId, setOrgTypeId] = useState("");
	const [regdType, setRegdType] = useState("");

	const [industryDataId, setIndustryDataId] = useState(null);

	const { getallorgsList, selectedinstituteId }
		= useSelector(
			(state) => state.getRegdIns
		);
	useEffect(() => {
		// dispatch(fetchAllOrgsData()); 
		dispatch(fetchOrgRegdInsData());

	}, [dispatch]);

	const handleInstitute = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectGetInstitute(selectedOption.value));
			setIndustryDataId(selectedOption.value);
			setOrgTypeId(selectedOption.tagId);
			setRegdType(selectedOption.tagId);

		} else {
			setIndustryDataId(null);
		}
	};
	console.log("userEducation", userEducation);

	useEffect(() => {
		if (userEducation) {
			setIndustryDataId(userEducation?.institutionId);
			setIndustryDataName(userEducation?.institutionName);
			setOrgTypeId(userEducation?.orgTypeId);
			setDegree(userEducation?.degree);
			setField(userEducation?.field);
			setAcademicAchiv(userEducation?.usrDataEducationAchievements);
			setActivities(userEducation?.activities);
			setqualificationId(userEducation?.qualification);
			setSpecilizationId(userEducation?.specilization);
			setGrade(userEducation?.grade);
			setActivities(userEducation?.activities);
			// setCityName(userEducation?.cityName);
			// setCityId(userEducation?.cityId);
			setCityId(userEducation.cityId || "");
			setTempCity({ value: userEducation.cityId, label: userEducation.cityName });
			dispatch(fetchCityData(userEducation.cityName || ""));
			dispatch(fetchCityData(userEducation?.cityName));
			setDescription(userEducation?.description);
			setIsPresent(userEducation.isPresent);
			// setStartDate(userEducation.startMonth, userEducation.startYear);
			// setEndDate(userEducation.endMonth, userEducation.endYear);

			const startYear = userEducation.startYear;  
			const startMonth = userEducation.startMonth; 
			if (startYear && startMonth) {
				const formattedStartDate = new Date(`${startYear}-${startMonth}-01`);
				setStartDate(formattedStartDate);
			}

			const endYear = userEducation.endYear;  
			const endMonth = userEducation.endMonth; 
			if (endMonth && endYear) {
				const formattedStartDate = new Date(`${endYear}-${endMonth}-01`);
				setEndDate(formattedStartDate);
			}


		}
	}, [userEducation, show]);

	console.log("start year and month ", userEducation.endMonth, userEducation.endYear, userEducation.startMonth, userEducation.startYear);

	// console.log("industryDataId", industryDataId, userEducation);





	const handleSpecializationChange = (inputValue, { action }) => {
		if (action === "input-change") {
			setSpecilizationId(inputValue);
		}
	};

	const handleQualificationChange = (inputValue, { action }) => {
		if (action === "input-change") {
			setqualificationId(inputValue);
		}
	};

	return (
		<Modal show={show} onHide={handleClose} centered size="lg">
			<Modal.Header>
				<Modal.Title>Update education</Modal.Title>
				<CloseSharpIcon className="pointer" onClick={handleClose} />
			</Modal.Header>
			<Modal.Body className="settings">
				<Row>
					{/* Institution and City */}
					<Col md={6} className="mb-2">
						<Form.Group controlId="institution">
							<Form.Group controlId="Industry">
								<Form.Label className="class-type">
									Institute <span className="text-red">*</span>
								</Form.Label>
								{InsName !== "" ? (
									<div>
										<input
											type="text"
											value={InsName}
											placeholder="Enter institute name"
											className="mb-2 form-control"
											disabled
										/>
									</div>
								) : (
									<div className="post-form-group mb-0">
										<ReactSelect
											options={getallorgsList}
											onChange={(selectedOption) => handleFieldChange(handleInstitute, selectedOption)}

											// onChange={(option) => {
											//   handleFieldChange(setIndustryDataId, option ? option.value : ""); // Track changes
											//   setOrgType(option ? option.tag : ""); // Set organization type
											// }}
											// value={
											// 	getallorgsList.find(
											// 		(option) => option.value === industryDataId
											// 	) || null
											//}
											value={
												getallorgsList.find(
													(option) => {
														if (InsName !== "" && InsName !== null) {
															return option.value === InsName;
														} else {
															return option.value === industryDataId && option.tagId === orgTypeId;
														}
													}
												) || null
											}
											onInputChange={(inputValue) => {
												setIndustryDataName(inputValue);
											}}
											getOptionValue={(option) => `${option.value}-${option.tagId}`}
											formatOptionLabel={(option) => (
												<div style={{ fontWeight: option.tagId === 1 ? "bold" : "normal" }}>
													{option.label}
												</div>
											)}
											placeholder="Select institute"
											classNamePrefix="react-select"
											className="form-control Dark-Input-from-group"
											styles={customStyles}
											isClearable
										/>
										{display && !industryDataName ? (
											<span className="error_msg_lbl">Select institute </span>
										) : null}
									</div>
								)}
							</Form.Group>
							{display && !industryDataId ? (
								<span className="error_msg_lbl">Select institute </span>
							) : null}
							<a
								href="#"
								ref={targetRef}
								onClick={(e) => {
									e.preventDefault();
									toggleTooltip();
								}}
								className="createModal"
							// isDisabled={!selectedIndustryId} // Disable until industry is selected
							>
								Create New
							</a>
							<Overlay
								target={targetRef.current}
								show={showTooltip}
								placement="right"
								rootClose
								container={document.querySelector(".modal")}
								onHide={() => setShowTooltip(false)} // Close when clicking outside
							>
								<Popover id="popover-basic" className="overlay-popover-modal">
									<Popover.Header className="Dark-Body-Card-group" as="h3">Create organization</Popover.Header>
									<Popover.Body className="Dark-Body-Card-group">
										<Form>
											<div>
												<label className="mb-1">Org name</label>
												<input
													type="text"
													value={OrganizationName}
													onChange={(e) => {
														setOrganizationName(e.target.value);
														setInsName(e.target.value);
														setIndustryDataId(e.target.value);
														handleFieldChange(setIndustryDataId, e.target.value, "industryDataId")
													}}
													placeholder="Enter org name"
													className="mb-2 form-control "
												/>
											</div>
											<div>
												<label className="mb-1">City</label>
												{/* <ReactSelect
                                                       options={cityList}
                                                       onChange={handleCitySelect1}
                                                        value={
                                                          cityList.find(
                                                            (option) => option.value === orgCity
                                                          ) || null
                                                        }
                                                        onInputChange={handleCityInputChange}
                                                        placeholder="Search & Select City"
                                                        classNamePrefix="react-select"
                                                        className="form-control Dark-Input-from-group"
                                                        styles={customStyles}
                                                        isClearable
                                                      /> */}
												<ReactSelect
													options={cityNameOption}
													onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
													onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
													placeholder="Search & select city"
													classNamePrefix="react-select"
													className="form-control Dark-Input-from-group"
													styles={customStyles}
													isClearable
												/>
											</div>
											<div className=" mt-2 mb-2">
												<label className="mb-1">Org logo</label>
												<input
													type="file"
													id="lastName"
													className="form-control Dark-Input-from-group"
													placeholder=""
													onChange={handleFileChange}
												//   onChange={(e) => {
												//     handleProfileImageChange(e);
												//   }}
												//   invalid={displays && profileImage === ""}
												/>
												{/* {displays && !profileImage ? (
                                                     <span className="error_msg_lbl text-red">
                                                       Upload Image{" "}
                                                     </span>
                                                 ) : null} */}
											</div>
											<div className="d-flex justify-content-end">
												<Button
													variant="primary"
													size="sm"
													onClick={() => {
														handleSaveInstitution()
														setShowTooltip(false);
													}}
													className="me-2"
												>
													Save
												</Button>
												<Button
													variant="secondary"
													size="sm"
													onClick={() => setShowTooltip(false)}
												>
													Cancel
												</Button>
											</div>
										</Form>
									</Popover.Body>
								</Popover>
							</Overlay>
						</Form.Group>
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">
								City <span className="text-red">*</span>
							</Form.Label>
						</Form.Group>
						<div className="post-form-group mb-0">

							<ReactSelect
								options={cityList}
								onInputChange={handleCityInputChange}
								onChange={handleCityChange}
								value={tempCity}
								placeholder="Search & select city"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable={true}
								onBlur={handleModalClose} 
							/>
						</div>
						{display && !cityId ? (
							<span className="error_msg_lbl">Search & select city </span>
						) : null}
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">Specialization <span className="text-red">*</span></Form.Label>
						</Form.Group>
						<div className="post-form-group">
							<ReactSelect
								options={SpecializationList}
								onInputChange={handleSpecializationChange}
								onChange={(option) => handleFieldChange(setSpecilizationId, option ? option.label : "")}
								value={
									SpecializationList.find((option) => option.label === specializationId) ||
									(specializationId ? { label: specializationId, value: specializationId } : null)
								}
								placeholder="Select specialization"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>
					</Col>
					<Col md={6} className="mb-2">
						<Form.Group controlId="city">
							<Form.Label className="class-type">Qualification <span className="text-red">*</span></Form.Label>
						</Form.Group>
						<div className="post-form-group">
							<ReactSelect
								options={qualficationList}
								onInputChange={handleQualificationChange}
								onChange={(option) => handleFieldChange(setqualificationId, option ? option.label : "")}
								value={
									qualficationList.find((option) => option.label === qualificationId) ||
									(qualificationId ? { label: qualificationId, value: qualificationId } : null)
								}
								placeholder="Select qualification"
								classNamePrefix="react-select"
								className="form-control Dark-Input-from-group"
								styles={customStyles}
								isClearable
							/>
						</div>
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="grade">
							<Form.Label className="class-type">Grade</Form.Label>
							<Form.Control
								type="text"
								value={grade}
								// onChange={(e) => setGrade(e.target.value)}
								onChange={(e) => handleFieldChange(setGrade, e.target.value)} // Track changes
								placeholder="Enter grade"
								className="Normal-Input-Fill"
							/>
						</Form.Group>
					</Col>

					<Col md={6} className="mb-2">
						<Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
							<Form.Label className="class-type col-md-12">
								Start year <span className="text-red"> *</span>
							</Form.Label>
							<Flatpickr
								type="number"
								value={startDate}
								// onChange={(date) => setStartDate(date[0])}
								onChange={(date) => handleFieldChange(setStartDate, (date[0]))} // Track changes
								placeholder="Enter start year"
								className="Dark-Input-from-group"
								options={{
									maxDate: new Date(), // Disable future dates
									static: true, // Keeps the calendar visible on click 
									dateFormat: "m-Y "
								}}
							// disabled={isPresent}
							/>
							{display && !startDate ? (
								<span className="error_msg_lbl">Enter start year</span>
							) : null}
						</Form.Group>
					</Col>

					{/* {userDataInfo.isPresentEducation === true && isPresent === false ? (
						""
					) : ( */}
					<Col md={6} className="d-flex align-items-center mb-2">
						<Form.Check
							type="checkbox"
							label="Is Present"
							checked={isPresent}
							// onChange={(e) => setIsPresent(e.target.checked)}
							onChange={(e) => {
								setIsPresent(e.target.checked);
								handleFieldChange(setIsPresent, e.target.checked);
							}}
						/>
					</Col>
					{/* )} */}

					{isPresent === false ? (
						<Col md={6} className="mb-2">
							<Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
								<Form.Label className="class-type col-md-12">End year</Form.Label>
								<Flatpickr
									type="number"
									value={endDate}
									// onChange={(date) => setEndDate(date[0])}
									onChange={(date) => handleFieldChange(setEndDate, (date[0]))} // Track changes
									placeholder="Enter end year"
									className="Dark-Input-from-group"
									disabled={isPresent}
									options={{
										minDate: startDate || null, // Set minDate to startDate
										static: true, // Keeps the calendar visible on click  
										dateFormat: "m-Y ",
									}}
								/>
							</Form.Group>
						</Col>
					) : (
						""
					)}

					{/* Description */}
					<Col md={12} className="mb-2">
						<Form.Group controlId="description">
							<Form.Label className="class-type">Description</Form.Label>
							<Form.Control
								as="textarea"
								rows={3}
								value={description}
								// onChange={(e) => setDescription(e.target.value)}
								onChange={(e) => handleFieldChange(setDescription, e.target.value)} // Track changes
								placeholder="Enter description"
								className="Normal-Input-Fill"
							/>
						</Form.Group>
					</Col>
				</Row>

				{/* Submit Button */}
				<div className="d-flex justify-content-end mt-4">

					<div className="add-class-submit-button mt-4 d-flex justify-content-center">
						<div className="khojPrimaryBtn ms-3"
						onClick={handleSubmit}
						style={{cursor: formChanged ? "pointer" : "default"}}
						>
							<a href="#/"
								// onClick={handleSubmit}
								className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
								// onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
								disabled={!formChanged || isSubmitting}
								style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
							>

								Submit
							</a>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default EditEducation;
